import type { FC } from 'react';
import { Card, CardContent, CardHeader, Skeleton } from '@/components/ui';

/**
 * Skeleton loader for TournamentCard component
 * Displays a loading state that matches the layout of TournamentCard
 */
export const TournamentCardSkeleton: FC = () => {
  return (
    <Card className="bg-white border-turquoise-200 shadow-md">
      <CardHeader>
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-2">
            {/* Swords icon skeleton */}
            <Skeleton className="h-5 w-5" />
            {/* Title skeleton */}
            <Skeleton className="h-6 w-48" />
          </div>
          {/* Status badge skeleton */}
          <Skeleton className="h-6 w-32" />
        </div>
        {/* Weapon and division badges skeleton */}
        <div className="flex gap-2 mt-2">
          <Skeleton className="h-6 w-24" />
          <Skeleton className="h-6 w-24" />
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {/* Capacity badge skeleton (centered) */}
          <div className="flex justify-center">
            <Skeleton className="h-6 w-40" />
          </div>

          {/* Participant count skeleton */}
          <div className="flex items-center gap-2">
            <Skeleton className="h-4 w-4" />
            <Skeleton className="h-4 w-40" />
          </div>

          {/* Progress bar skeleton */}
          <Skeleton className="h-2 w-full" />

          {/* Registration fee skeleton */}
          <div className="flex items-center gap-2">
            <Skeleton className="h-4 w-4" />
            <div className="flex items-center gap-2 flex-wrap">
              <Skeleton className="h-6 w-24" />
              <Skeleton className="h-4 w-44" />
            </div>
          </div>

          {/* Early bird pricing end date skeleton */}
          <div className="ml-6">
            <Skeleton className="h-3 w-56" />
          </div>

          {/* Registration button skeleton */}
          <Skeleton className="h-10 w-full mt-4" />
        </div>
      </CardContent>
    </Card>
  );
};
